export default "__VITE_ASSET__869018bf__"